import {useRoutes} from 'react-router-dom';
import routeConfig from './RouteConfig';

export default function AppRouter() {
    return useRoutes(routeConfig);
}
